import { Container } from '@mui/material';
import { NextPage } from 'next';
import Head from 'next/head';
import useTranslation from 'next-translate/useTranslation';
import HeaderBar from '@components/HeaderBar';
import SitemapContent from '@screens/Sitemap/SitemapContent';
import { MARGIN_BEFORE_FOOTER } from '@styles/consts';

export interface DecisionsPageProps {
    years: string[];
}

const DecisionsPage: NextPage<DecisionsPageProps> = ({ years }) => {
    const { t } = useTranslation('sitemap');

    return (
        <>
            <HeaderBar title={t('headerBar.title')} />
            <Head>
                <title>{t('pageTitle.allYears')}</title>
            </Head>
            <Container maxWidth="md" sx={{ mb: MARGIN_BEFORE_FOOTER }}>
                <SitemapContent title={t('title')} years={years} />
            </Container>
        </>
    );
};

export default DecisionsPage;
